import React from 'react'
import appTypeConfigFunc from 'apptype-config'
import { lazy } from '@loadable/component'

const config = {
  fallback: <div />,
}

let defaultRoutes = [
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login'), config),
    exact: true,
  },
  {
    path: '/auth/sso/:key',
    Component: lazy(() => import('pages/auth/loginByKey'), config),
    exact: true,
  },
  {
    path: '/auth/sso',
    Component: lazy(() => import('pages/auth/loginByKey'), config),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen'), config),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404'), config),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500'), config),
    exact: true,
  },
]

if (process.env.REACT_APP_TARGET !== 'production') {
  defaultRoutes = [
    ...defaultRoutes,
    {
      path: '/test/edit',
      Component: lazy(() => import('pages/test/edit'), config),
    },
  ]
}

const routeInfo = {
  prev: null,
  map: null,
}

export function clearRoutes() {
  routeInfo.prev = null
  routeInfo.map = null
}

export default function getRoutes() {
  const routerFunc = appTypeConfigFunc().router

  const myRoutes = [...defaultRoutes, ...routerFunc(config)]

  let isChanged = true
  if (routeInfo.prev != null) {
    isChanged = routeInfo.prev.length !== myRoutes.length
    if (isChanged === false) {
      if (routeInfo.map == null) {
        routeInfo.map = {}
        routeInfo.prev.forEach((item) => {
          routeInfo.map[item.path] = item
        })
      }
      isChanged = myRoutes.some((route) => {
        return routeInfo.map[route.path] == null
      })
    }
  }

  if (isChanged === true) {
    routeInfo.prev = myRoutes
    routeInfo.map = null
  } else {
    return routeInfo.prev
  }

  return myRoutes
}
